import { render, staticRenderFns } from "./HekimGuncelleme.vue?vue&type=template&id=57e47313&"
import script from "./HekimGuncelleme.vue?vue&type=script&lang=js&"
export * from "./HekimGuncelleme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports